import { css, styles } from 'helpers'
import React, { useEffect, useState } from 'react'
import { ReactComponent as Billetten } from 'resources/billetten.svg'
import { Fade } from 'webbook-airways'

export default function Splashscreen({ isOpen }) {
  const [show, setShow] = useState(true)

  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => setShow(false), 750)
      return () => clearTimeout(timeout)
    }
  }, [isOpen])

  if (!show) {
    return null
  }
  return (
    <Fade fadeIn={isOpen} timeout={{ enter: 0, exit: 750 }}>
      <div
        className={css({
          zIndex: 99999999999999999999,
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: styles.colors.primary
        })}
      >
        <Billetten
          fill="white"
          style={{ height: 120, width: 600, marginTop: -50 }}
        />
      </div>
    </Fade>
  )
}
